<!--
  ~ Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
  ~ This software is the proprietary information of NEXTWELL INTL SRL.
  ~ Use is subject to license and non-disclosure terms
  -->

<div class="right-side">
    <google-map
            #maps
            [center]="{lat: location?.latitude, lng: location?.longitude}"
            [zoom]="zoom"
            [height]="height"
            width="100%"
            (mapInitialized)='onMapReady($event)'
            (centerChanged)="centerChanged(maps.getCenter())"
            [options]="{
                disableDefaultUI: true,
                scrollwheel: false,
                gestureHandling: 'cooperative',
                mapTypeControl: false,
                streetViewControl: false,
                zoomControl: false
            }"
    />

    <p *ngIf="error" class="color-danger mt"> {{'address.error.' + error | translate}} </p>

    <p *ngIf="showLocationChangedMessage" class="color-info mt"> {{'address.locationChanged' | translate}} </p>

    <button *ngIf="centerLatLng"
            type="button"
            pButton class="p-button-rounded p-button-info btn-xs update-address" icon="ui-icon-add-location"
            label="{{'address.search-box.update-address' | translate}}"
            (click)="click()" data-testid="click-btn"></button>
    <div class="map-center-marker"><i class="ui-icon-place large"></i></div>
</div>




